import { useState, useEffect } from 'react';
import { nanoid } from 'nanoid';
import { isLive } from 'consts/Env';

/**
 * PayPal FraudNet
 * @param merchantId マーチャントID
 * @returns f FraudNet用fパラメータ(セッションごとのID。ページが読み込まれるたびに変わる）
 */
export const useFraudNet = (merchantId: string) => {
	// FraudNet用 セッションごとのID（ページが読み込まれるたびに変わる）
	const [f] = useState(nanoid(32));

	// FraudNet
	useEffect(() => {
		if (!merchantId) {
			return;
		}
		const s = `GAKKEN_${merchantId}_RT`;

		const script1 = document.createElement('script');
		script1.type = 'application/json';
		script1.setAttribute('fncls', 'fnparams-dede7cc5-15fd-4c75-a9f4-36c430ee3a99');
		script1.text = JSON.stringify({ f, s, sandbox: !isLive });

		const script2 = document.createElement('script');
		script2.type = 'text/javascript';
		script2.src = 'https://c.paypal.com/da/r/fb.js';

		const noscript = document.createElement('noscript');
		const img = document.createElement('img');
		img.src = `https://c.paypal.com/v1/r/d/b/ns?f=${f}&s=${s}&js=0&r=1`;
		noscript.appendChild(img);

		const head = document.getElementsByTagName('head')[0] as HTMLElement;
		head.appendChild(script1);
		head.appendChild(script2);
		const body = document.getElementsByTagName('body')[0] as HTMLElement;
		body.appendChild(noscript);
	}, [merchantId]);

	return {
		f,
	};
};
